import { SocketChannel } from '../core/channel'
import { EVENTS_ENUM } from './events'
import { verificationStatus } from './events/verificationStatus'

class VerificationChannel extends SocketChannel {
  constructor() {
    super()
    this.register(EVENTS_ENUM.VERIFICATION, verificationStatus)
  }
}

export const verificationChannel = new VerificationChannel()
